/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lifetime_EarningsInputs */

const en_lifetime_earnings = /** @type {(inputs: Lifetime_EarningsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lifetime Earnings`)
};

const es_lifetime_earnings = /** @type {(inputs: Lifetime_EarningsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ganancias de por vida`)
};

const fr_lifetime_earnings = /** @type {(inputs: Lifetime_EarningsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gains à vie`)
};

const de_lifetime_earnings = /** @type {(inputs: Lifetime_EarningsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lebenszeiteinnahmen`)
};

const ja_lifetime_earnings = /** @type {(inputs: Lifetime_EarningsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`生涯収益`)
};

const zh_lifetime_earnings = /** @type {(inputs: Lifetime_EarningsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`终身总收益`)
};

const ar_lifetime_earnings = /** @type {(inputs: Lifetime_EarningsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الأرباح مدى الحياة`)
};

const id_lifetime_earnings = /** @type {(inputs: Lifetime_EarningsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penghasilan Seumur Hidup`)
};

const it_lifetime_earnings = /** @type {(inputs: Lifetime_EarningsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guadagni Complessivi`)
};

const ru_lifetime_earnings = /** @type {(inputs: Lifetime_EarningsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Заработок за все время`)
};

const pt_lifetime_earnings = /** @type {(inputs: Lifetime_EarningsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ganhos Totais (Lifetime)`)
};

const ko_lifetime_earnings = /** @type {(inputs: Lifetime_EarningsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`총 누적 수익`)
};

/**
* | output |
* | --- |
* | "Lifetime Earnings" |
*
* @param {Lifetime_EarningsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const lifetime_earnings = /** @type {((inputs?: Lifetime_EarningsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lifetime_EarningsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_lifetime_earnings(inputs)
	if (locale === "es") return es_lifetime_earnings(inputs)
	if (locale === "fr") return fr_lifetime_earnings(inputs)
	if (locale === "de") return de_lifetime_earnings(inputs)
	if (locale === "ja") return ja_lifetime_earnings(inputs)
	if (locale === "zh") return zh_lifetime_earnings(inputs)
	if (locale === "ar") return ar_lifetime_earnings(inputs)
	if (locale === "id") return id_lifetime_earnings(inputs)
	if (locale === "it") return it_lifetime_earnings(inputs)
	if (locale === "ru") return ru_lifetime_earnings(inputs)
	if (locale === "pt") return pt_lifetime_earnings(inputs)
	return ko_lifetime_earnings(inputs)
});